import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
// ⚠️ 请勿修改，引入自动生成的 App
import App from './src/app';
import './assets/style/reset.css';
import Image from 'lib/components/Image';
import 'plugins/FlowInit/index.scss';
import 'components/Container/index.scss';

const data = {
  portraitBackgroundImg: 'https://vfiles.gtimg.cn/pub/flow.t_img/8cb44e1f_hKjnfeyyRDc.jpg',
  landscapeBackgroundImg: 'https://vfiles.gtimg.cn/pub/flow.t_img/8cb44e1f_Tw2aa1v76xR.jpg'
}

ReactDOM.render(
  <App>
    { props => <div className="container">
      <Image data={data} />
    </div> }
  </App>,
  document.getElementById('react-body'));
